<div *ngIf="userDetailsStore.state$ | async as state" [ngSwitch]="data.changeType">
  <ng-container *ngIf="state.saved">
    <mat-card>
      <mat-card-content>
        {{ '+USER_DETAILS.CHANGED.SUCCESS' | translate }}
      </mat-card-content>
      <mat-card-actions align="end">
        <button
          id="close-btn"
          mat-raised-button
          color="primary"
          gtm="onClose"
          gtmCategory="Change user`s details modal"
          (click)="onCancel()"
        >
          {{ 'GENERAL.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>
  <ng-container *ngIf="!state.saved">
    <vi-overlay-progress-bar *ngIf="state.saving"></vi-overlay-progress-bar>
    <app-personal-details
      *ngSwitchCase="'personal'"
      [userRole]="userRole$ | async"
      [details]="personal$ | async"
      [isEmailVerified]="isEmailVerified$ | async"
      (cancel)="onCancel()"
      (save)="onSave($event)"
    ></app-personal-details>
    <app-address-details
      *ngSwitchCase="'address'"
      [details]="address$ | async"
      (cancel)="onCancel()"
      (save)="onSave($event)"
    ></app-address-details>
    <app-contact-details
      *ngSwitchCase="'contact'"
      [details]="contact$ | async"
      (cancel)="onCancel()"
      (save)="onSave($event)"
    ></app-contact-details>
    <app-other-details
      *ngSwitchCase="'other'"
      [details]="contact$ | async"
      (cancel)="onCancel()"
      (save)="onSave($event)"
    ></app-other-details>
  </ng-container>
</div>
